const ProfileTab = ({ t, id }) => {
  return (
    <div>
      <section className="bg-[#182443] p-8 rounded-lg space-y-4">
        <h3 className="text-lg font-bold">{t("personalInfo")}</h3>
        <div className="flex flex-wrap items-center md:flex-nowrap">
          <div className="w-full">
            <p className="font-bold text-primary">{t("fullName")}:</p>
            <p className="mt-2 text-xl font-semibold">{id}</p>
          </div>
          <div className="w-full">
            <p className="font-bold text-primary">{t("idNumber")}:</p>
            <p className="mt-2 text-xl font-semibold">1234567890</p>
          </div>
        </div>
        <div className="flex flex-wrap items-center md:flex-nowrap">
          <div className="w-full">
            <p className="font-bold text-primary">{t("email")}:</p>
            <p className="mt-2 text-xl font-semibold">employee@example.com</p>
          </div>
          <div className="w-full">
            <p className="font-bold text-primary">{t("phone")}:</p>
            <p className="mt-2 text-xl font-semibold">+966 50 123 4567</p>
          </div>
        </div>
        <div>
          <p className="font-bold text-primary">{t("birthDate")}:</p>
          <p className="mt-2 text-xl font-semibold">15/05/1990</p>
        </div>
      </section>
      <section className="bg-[#182443] p-8 rounded-lg space-y-4 mt-4">
        <h3 className="text-lg font-bold">{t("contactInfo")}</h3>
        <div className="flex flex-wrap items-center md:flex-nowrap">
          <div className="w-full">
            <p className="font-bold text-primary">{t("city")}:</p>
            <p className="mt-2 text-xl font-semibold">الرياض</p>
          </div>
          <div className="w-full">
            <p className="font-bold text-primary">{t("address")}:</p>
            <p className="mt-2 text-xl font-semibold">
              الرياض، المملكة العربية السعودية
            </p>
          </div>
        </div>
        <div className="flex flex-wrap items-center md:flex-nowrap">
          <div className="w-full">
            <p className="font-bold text-primary">{t("emergencyPhone")}:</p>
            <p className="mt-2 text-xl font-semibold">+966 50 987 6543</p>
          </div>
          <div className="w-full">
            <p className="font-bold text-primary">{t("zipCode")}:</p>
            <p className="mt-2 text-xl font-semibold">12345</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProfileTab;
